import { render, staticRenderFns } from "./vuex-form-dialog.vue?vue&type=template&id=aa823cd8"
import script from "./vuex-form-dialog.vue?vue&type=script&lang=js"
export * from "./vuex-form-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports